/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_Col_KeyInputs */

const en_wc_tut_keys_col_key = /** @type {(inputs: Wc_Tut_Keys_Col_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortcut`)
};

/**
* | output |
* | --- |
* | "Shortcut" |
*
* @param {Wc_Tut_Keys_Col_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_col_key = /** @type {((inputs?: Wc_Tut_Keys_Col_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_Col_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_col_key(inputs)
});
export { wc_tut_keys_col_key as "wc.tut.keys.col_key" }